import config from '../app-config';
import contactPersonImg from '../images/contact-persoon.png';


const InformationSection = (props) => {
    return (
        // <div className="row justify-content-start" id={props.id}>
        <div className="row justify-content-center" id={props.id}>
            {/* <div className="col-md-6 col-12">
                <img className="img-fluid offset-md-5 offset-md-4 offset-sm-3" src={contactPersonImg} id="contact-img" alt="contact-persoon"/>
            </div> */}
            {/* <div className="col-md-6 col-12"> */}
            <div className="col-12 text-center">
                {/* <div className="col-md-8 offset-lg-2 offset-md-4  text-center text-md-left"> */}
                    <h2>Contact</h2>
                    {/* <div className="text-center text-md-left"> */}
                        {config.contactInfos.map(contact => (
                            <div className="well" key={contact.id}>
                                <h4>{contact.supportiveText}</h4>
                                <p>{contact.name}</p>
                                <p>{contact.telephoneNumber}</p>
                            </div>
                        ))}
                {/* </div> */}
            </div>
        </div>
    );
}

export default InformationSection;
